import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import {GetRestaurants, RestaurantGet, CreateRestaurant, UpdateRestaurant, DeleteRestaurant} from '../../api/restaurant'
import {GetByText} from '../../api/log'

const Log = ({ token }) => {
    const GetObjs = GetRestaurants
    const GetObj = RestaurantGet
    const CreateObj = CreateRestaurant
    const DeleteObj = DeleteRestaurant
    const UpdateObj = UpdateRestaurant
    const SearchObjs = GetByText

    const [selectedObj, setSelectedObj] = useState()

    const [startData, setStartDate] = useState()
    const [tableObjs, setTableObjs] = useState()
    const [searchFieldObjs, setSearchFieldsObjs] = useState([])
    const [createForm, setCreateForm] = useState({})
    const [numPage, setNumPage] = useState(1)
    const [updateForm, setUpdateForm] = useState({})
    const [searchValues, setSearchValues] = useState({})

    const headerFieldsName = ['id', 'Действие', 'Тип', "Когда", "Пользователь", ]
    const nameFieds = ['id', 'action', 'type_action', 'datetime', 'user_id',]
    // const searchField = ['action']
    // const searchMethod = [GetByText]

    // const fetchProfile = async () => {
    //     // const data = await GetObjs(token, numPage, 10)
    //     // setStartDate(data)
    //     // setTableObjs(renderTable(data))
    //     // renderSearchFields()
    // };
    //     useEffect(() => {
    //         fetchProfile();
    //     }, [token]);

    async function selectObj(event, id){
        const obj = await GetObj(token, id)
        setSelectedObj(obj)
        setUpdateForm(obj)
    }

    function clickedCreateBtn(event){
        setSelectedObj()
    }

    async function createObj(event) {
        const data = await CreateObj(token, createForm)
        startData.data.push(data)
        setStartDate(startData)
        setTableObjs(renderTable(startData))
    }

    async function selectAnotherPage(event, numPage) {
        const data = await GetObjs(token, numPage, 10)
        setNumPage(numPage)
        setStartDate(data)
        setTableObjs(renderTable(data))
    }

    async function updateObj(event) {
        const data = await UpdateObj(token, updateForm)
        for (let row in startData.data){
            if (data.id == startData.data[row].id){
                startData.data[row] = data
            }
        }
        setStartDate(startData)
        setTableObjs(renderTable(startData))
    }

    function renderTable(data){
        let pages = []
        for (let i = 0; i < data.all_page; i++){
            pages.push(<li className="page-item" onClick={(e) => selectAnotherPage(e.stopPropagation(), i+1)}><a className="page-link" href="#">{i+1}</a></li>)
        } 
        return(
            <div className="content">
            <table className='table table-bordered'>
                <thead>
                    <tr>
                        {headerFieldsName.map(namefield => (
                            <th key={namefield}>{namefield}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.data.map((obj) => (
                        <tr key={obj.id} data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={(e) => selectObj(e.stopPropagation(), obj.id)}>
                            {nameFieds.map(nameField => (
                             <td key={nameField}>
                                {typeof obj[nameField] === 'boolean' ? String(obj[nameField]) : obj[nameField]}
                            </td>
                            ))}
                        </tr>
                    ))}
                    <tr>
                        <td colSpan={nameFieds.length} data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={clickedCreateBtn} >Создать</td>
                    </tr>
                </tbody>
            </table>
            <nav aria-label="Page navigation example">
                <ul className="pagination">
                    {pages.map(row => (
                        row
                    ))}
                </ul>
            </nav>
        </div>
        )
        
    }

    async function deleteObj(event) {
     const data = await DeleteObj(token, updateForm.id)
     for (let row in startData.data){
            if (data.id == startData.data[row].id){
                startData.data.splice(row,1)
            }
        }
    setStartDate(startData)
    setTableObjs(renderTable(startData))
    }

    async function searchMethod(event) {
        const text = event.target.value
        const objs = await SearchObjs(token, text)
        const data = {'data': objs}
        setStartDate(data)
        setTableObjs(renderTable(data))

    }
    
  return (
    <div className="content">
        <div className="search">
            <input type="text" name="" id=""onChange={searchMethod} />
        </div>
        <div className="table">
        {tableObjs}
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog">
            <div className="modal-content">
            <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
                
                { (selectedObj) && (nameFieds.map(field => (
                    <div className="block justify-content-center">
                        <p>{field}</p>
                        <textarea name="" id="" value={updateForm[field]}
                        onChange={(e) => setUpdateForm({
                            ...updateForm,
                            [field]: e.target.value
                        })}
                        ></textarea>
                    </div>
                    )
                )
                )
                }
                { (!selectedObj)&& (nameFieds.map(field => (
                    <div className="block justify-content-center">
                        <p>{field}</p>
                        <textarea value={createForm[field] || ''}
                            onChange={(e) => setCreateForm({
                                ...createForm,
                                [field]: e.target.value
                        })}></textarea>
                    </div>
                    )
                )
                )}


            </div>
            <div className="modal-footer">
                <button type="button" className="btn " onClick={updateObj}>Обновить</button>
                <button type="button" className="btn" onClick={createObj}>Создать</button>
                <button type="button" className="btn" onClick={deleteObj}>Удалить</button>
            </div>
            </div>
        </div>
        </div>
        
    </div>
    </div>
    
    );
};

export default Log;
